import React from "react"
import Utils from "../utils/node.utils"
import { StaticQuery, graphql } from "gatsby"
import StaticPage from "../components/StaticPage/StaticPage"
import {
  createOverlay,
  createContentList,
} from "../contentfunctions/cookies.js"

import Carousel1 from "../images/cookies/cookies-min.jpeg"

const CookiesPage = ({ location }) => {
  Utils.NavigateToBrowserLanguage("en", "/cookies", location.state)
  return (
    <StaticQuery
      query={pageQuery}
      render={data => {
        const commonContentMap = Utils.ContentListToMap(
          data.commonContent.item.content
        )
        const contentMap = Utils.ContentListToMap(
          data.cookiesContent.item.content
        )
        const img = {
          src: Carousel1,
          altText: contentMap.seo_title.value,
          caption: contentMap.seo_description.value,
        }
        return (
          <StaticPage
            img={img}
            originPage="cookies"
            location={location}
            contentMap={contentMap}
            commonContentMap={commonContentMap}
            title={contentMap.seo_title.value}
            description={contentMap.seo_description.value}
            breadCrumbs={["menu_home", "menu_cookies"]}
            createContentFun={createContentList}
            createOverlayFun={createOverlay}
            keywords={Utils.GetKeywordsFromTags(data.cookiesContent.item.tags)}
          />
        )
      }}
    />
  )
}

export default CookiesPage

const pageQuery = graphql`
  {
    cookiesContent: cookiesContentEngb {
      item {
        key
        tags {
          content {
            key
            value
          }
        }
        content {
          key
          value
        }
      }
    }

    commonContent: commonContentEngb {
      item {
        key
        content {
          key
          value
        }
      }
    }
  }
`
